module.exports = __webpack_public_path__ + "img/exposicion_humana_glifosato_movil.e779385b.png";